module.exports = __webpack_public_path__ + "img/Visa2.5d6da973.jpg";